import { Spine } from '@esotericsoftware/spine-pixi-v8';
import {
    Container, /*Sprite,*/ Graphics,
    Sprite
} from 'pixi.js';
// import { /*spinResponse,*/ initData/*, SpinDataObject/*, spinData /*, WinObject*/ } from '../server/getServerResposesFun'
import { EventEmitter } from "pixi.js";

export const reelSpinEmitter = new EventEmitter();

import { getSpineSymbol, getSymbol, isIdleExist } from '../config/getSymbol';
import { RespinIndex } from '../config/GlobalVariableConfig';
import {
    REEL_DIVIDER,
    REEL_FRAME,
    REEL_NUMBERS,
    REEL_WIDTH,
    SHOWN_REELS_HEIGHT,
    SYMBOL_HEIGHT,
    SYMBOL_WIDTH,
    SYMBOLS_PER_REEL
} from "../config/reelConfig";
import { EventConstants } from '../gameClientEvents/EventConstants';
import { spinData } from '../server/getServerResposesFun';

export const DummyReelSymbol = [
    [3, 6, 1, 3, 6, 8, 3, 6, 3, 6, 8, 1, 6, 3, 8, 6, 1, 6, 8, 3, 6, 1, 3, 8, 6, 1, 3, 8, 6, 3, 1, 6, 8, 3, 6, 1, 3, 8, 1, 3, 8, 6, 1, 3, 8, 3, 6, 3, 1, 8, 3, 6, 8, 1, 3, 8, 3, 6, 8, 1, 3, 6, 8, 1, 3, 6, 8, 3, 6, 8, 3, 3, 6, 8, 1, 3, 6, 8, 3, 1, 8, 3]
    , [2, 7, 4, 2, 7, 2, 7, 2, 4, 7, 2, 7, 4, 2, 7, 4, 7, 2, 7, 4, 2, 7, 2, 4, 7, 2, 7, 4, 2, 7, 4, 2, 2, 7, 4, 2, 7, 2, 4, 7, 2, 4, 7, 2, 2, 7, 2, 4, 2, 7, 4, 2, 2, 7, 2, 7, 4, 2, 7, 2, 4, 2]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
    , [2, 6, 1, 2, 6, 3, 7, 2, 1, 7, 3, 7, 6, 1, 1, 7, 2, 3, 6, 1, 7, 6, 3, 2, 4, 7, 2, 6, 4, 3, 8, 4, 2, 8, 6, 1, 2, 8, 3, 6, 2, 1, 3, 7, 8, 1, 3, 2, 6, 8, 1, 3, 7, 6, 1, 3, 2, 7, 8, 3, 2, 6, 1, 2, 6, 3, 1, 8, 3]
]

export const DummyReelSymbol1 = [
    [3, 6, 1, 3, 6, 8, 3, 6, 3]
    , [3, 6, 1, 3, 6, 8, 3, 6, 3]
    , [3, 6, 1, 3, 6, 8, 3, 6, 3]
    , [3, 6, 1, 3, 6, 8, 3, 6, 3]
    , [3, 6, 1, 3, 6, 8, 3, 6, 3]
]

export interface SymbolObject {
    symbolIndex: number
    id: number;
    y: number
    view: Container;
    symbol: Sprite;
}

export interface ReelObject {
    reelIndex: number
    container: Container;
    symbols: SymbolObject[];
}




export class ReelInit extends Container {

    public allReelArray: ReelObject[];
    public anticipation: Spine[];

    private allReelContainer: Container;

    public reelOverlayContainer: Container;
    public toggleOverlayContainer: Container;
    public reelSymbolContainers: Container[][] = [];
    public reelSymbols: Spine[][] = [];

    public reelSymbolsBeforeSpin: number[][] = [];

    constructor() {
        super();

        this.allReelContainer = new Container();
        this.allReelArray = [];
        this.reelOverlayContainer = new Container();
        this.toggleOverlayContainer = new Container();
        this.toggleOverlayContainer.label = "toggleOverlay";
        this.anticipation = [];

        this.initReels();

    }

    private initReels() {

        for (let i = 0; i < REEL_NUMBERS; i++) {

            const reelContainer = new Container();
            const reelObj: ReelObject = {
                reelIndex: i,
                container: reelContainer,
                symbols: [],
                // symbolIds: [],
                // symbols: [],
                // indexOfContInView: 0
            };



            reelContainer.x = REEL_FRAME + i * (REEL_WIDTH + REEL_DIVIDER);
            reelContainer.y = REEL_FRAME;

            const reelRand = Math.floor(Math.random() * (DummyReelSymbol[i].length - SYMBOLS_PER_REEL));
            const reelSymbolIds =
                RespinIndex.value === 0 ?
                    DummyReelSymbol[i].slice(reelRand, reelRand + SYMBOLS_PER_REEL + 1)
                    :
                    spinData.respins[RespinIndex.value - 2].reelSymbols[i];


            this.reelSymbolsBeforeSpin.push(reelSymbolIds);

            for (let j = 0; j < SYMBOLS_PER_REEL + 1; j++) {
                const symbolContainer = new Container();

                let index = (j == SYMBOLS_PER_REEL) ? j - 1 : j;
                const symbolId = reelSymbolIds[index];

                let symbol = new Sprite(getSymbol(symbolId));

                symbolContainer.addChild(symbol);
                symbol.anchor = 0.5;
                symbolContainer.y = (SYMBOL_HEIGHT / 2) + j * SYMBOL_HEIGHT;
                symbolContainer.x = Math.round(SYMBOL_WIDTH / 2);

                if (j == SYMBOLS_PER_REEL) { // the extra symbol - which will appear on top of mark - having (symbolIndex = SYMBOLS_PER_REEL)
                    symbolContainer.y = - (SYMBOL_HEIGHT / 2);
                }
                const symbolObj: SymbolObject = {
                    symbolIndex: j,
                    id: symbolId,
                    y: symbolContainer.y,
                    view: symbolContainer,
                    symbol: symbol,
                }

                reelObj.symbols.push(symbolObj);
                reelContainer.addChild(symbolContainer);

            }


            this.allReelContainer.addChild(reelContainer);
            this.allReelArray.push(reelObj);

            this.anticipation[i] = Spine.from({
                skeleton: "anticipationSkel",
                atlas: "anticipationAtlas",
            });

            this.anticipation[i].x = REEL_FRAME + REEL_WIDTH / 2 + i * (REEL_WIDTH + REEL_DIVIDER);
            this.anticipation[i].y = 90 + REEL_FRAME + SHOWN_REELS_HEIGHT / 2;
        }

        const reactMark = new Graphics().rect(REEL_FRAME, REEL_FRAME, REEL_WIDTH * REEL_NUMBERS + (REEL_NUMBERS - 1) * REEL_DIVIDER, SYMBOL_HEIGHT * SYMBOLS_PER_REEL).fill(0x950a5a);
        this.allReelContainer.addChild(reactMark);
        reactMark.alpha = .5;
        this.allReelContainer.mask = reactMark;
        this.addChild(this.allReelContainer);


        this.reelOverlayContainer.destroy(true);
        this.toggleOverlayContainer.destroy(true);

        this.initReelOverlayContainer();
        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.addReelSymbolsToContainer(i);
        }

    }



    private initReelOverlayContainer() {
        this.reelOverlayContainer = new Container();
        this.reelOverlayContainer.label = "reelOverlay";
        this.reelOverlayContainer.x = this.allReelContainer.x;
        this.reelOverlayContainer.y = this.allReelContainer.y;
        this.toggleOverlayContainer = new Container();
        this.toggleOverlayContainer.label = "toggleOverlay";
        this.toggleOverlayContainer.x = this.allReelContainer.x;
        this.toggleOverlayContainer.y = this.allReelContainer.y;

        this.addChild(this.reelOverlayContainer);
        this.addChild(this.toggleOverlayContainer);


        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            this.reelSymbolContainers[reelNum] = [];
            this.reelSymbols[reelNum] = [];

            for (let posNum = 0; posNum < SYMBOLS_PER_REEL; posNum++) {
                const symbolCont = new Container();
                symbolCont.x = REEL_FRAME + Math.round(SYMBOL_WIDTH / 2) + reelNum * (REEL_WIDTH + REEL_DIVIDER);
                symbolCont.y = REEL_FRAME + Math.round(SYMBOL_HEIGHT / 2) + posNum * SYMBOL_HEIGHT;

                this.reelOverlayContainer.addChild(symbolCont);
                this.reelSymbolContainers[reelNum][posNum] = symbolCont;
                this.reelSymbols[reelNum][posNum] = null!;
            }
        }

        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.reelOverlayContainer.addChild(this.anticipation[i]);
        }
    }




    public addReelSymbolsToContainer(reelNum: number) {
        const reelObj = this.allReelArray[reelNum];

        for (let posNum = 0; posNum < SYMBOLS_PER_REEL; posNum++) {

            // clean old symbol first
            const prevSymbol = this.reelSymbols[reelNum][posNum];
            if (prevSymbol) {
                this.reelSymbolContainers[reelNum][posNum].removeChild(prevSymbol);
                prevSymbol.destroy();
                this.reelSymbols[reelNum][posNum] = null;
            }
            else {
                const symbolId = reelObj.symbols[posNum].id;
                const symbol = getSpineSymbol(symbolId);
                this.reelSymbolContainers[reelNum][posNum].addChild(symbol);
                this.reelSymbols[reelNum][posNum] = symbol;
            }

            this.reelSymbols[reelNum][posNum].state.setAnimation(0, "land", false);
            if (isIdleExist(reelObj.symbols[posNum].id)) {
                this.reelSymbols[reelNum][posNum].state.addAnimation(0, "idle", true);
            }

        }

        for (let i = 0; i < REEL_NUMBERS; i++) {
            this.reelOverlayContainer.addChild(this.anticipation[i]);
        }

        // Defer visibility change to the next frame
        requestAnimationFrame(() => {
            reelObj.container.visible = false;
        });

    }

    public resetReelOverlayContainer() {
        reelSpinEmitter.emit(EventConstants.OVERLAY_SYMBOLS_RESET);
        for (let reelNum = 0; reelNum < REEL_NUMBERS; reelNum++) {
            for (let posNum = 0; posNum < SYMBOLS_PER_REEL; posNum++) {

                const prevSymbol = this.reelSymbols[reelNum][posNum];
                if (prevSymbol) {
                    this.reelSymbolContainers[reelNum][posNum].removeChild(prevSymbol);
                    prevSymbol.destroy();
                    this.reelSymbols[reelNum][posNum] = null;
                }
            }
        }

    }

}
